module.exports = __webpack_public_path__ + "img/placeholder-tile-icon.c38df2e9.svg";